/**
 * Entity-type prefixes for Deckspace IDs.
 *
 * Every Deckspace-owned entity has a 3-character prefix followed by 16
 * base62 characters. Pattern is verbatim from Teable's id-generator.ts.
 *
 * See spec: docs/superpowers/specs/2026-05-18-id-system-overhaul-design.md
 */
export var IdPrefix;
(function (IdPrefix) {
    IdPrefix["Workspace"] = "wsp";
    IdPrefix["WorkspaceMember"] = "mbr";
    IdPrefix["Page"] = "pag";
    IdPrefix["Dataset"] = "dst";
    IdPrefix["Row"] = "row";
    IdPrefix["Surface"] = "srf";
    IdPrefix["Change"] = "chg";
    IdPrefix["UserPreference"] = "prf";
})(IdPrefix || (IdPrefix = {}));
export const BODY_LEN = 16;
export const ID_LEN = 3 + BODY_LEN; // 19
export const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
//# sourceMappingURL=prefixes.js.map